// src/services/perfilService.js

import api from './api';

export const criarPerfil = async (perfilData) => {
  try {
    const response = await api.post('/perfis-usuario', perfilData);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar perfil:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao criar perfil');
  }
};

export const criarUsuarioPerfil = async (dados) => {
  try {
    const response = await api.post('/perfis-usuario/novo', dados);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar usuário e perfil:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao criar usuário e perfil');
  }
};

export const listarPerfis = async (instituicaoId, page = 1, limit = 5) => {
  try {
    const url = page && limit 
      ? `/perfis-usuario/instituicao/${instituicaoId}?page=${page}&limit=${limit}`
      : `/perfis-usuario/instituicao/${instituicaoId}`;
    
    console.log('🌐 Fazendo requisição para:', url);
    const response = await api.get(url);
    console.log('📡 Resposta da API:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao listar perfis:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao listar perfis');
  }
};

export const obterPerfil = async (perfilId) => {
  try {
    const response = await api.get(`/perfis-usuario/${perfilId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao obter perfil:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao obter perfil');
  }
};

export const atualizarPerfil = async (perfilId, perfilData) => {
  try {
    // Garantir que os dados estão no formato correto
    const dadosAtualizados = {
      tipo: perfilData.tipo,
      status: perfilData.status,
      permissoes: perfilData.permissoes, // Agora suporta array completo de permissões
      instituicao_id: perfilData.instituicaoId
    };

    const response = await api.put(`/perfis-usuario/${perfilId}`, dadosAtualizados);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar perfil:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao atualizar perfil');
  }
};

export const validarPermissoes = async (perfilId, permissoes) => {
  try {
    const response = await api.post(`/perfis-usuario/${perfilId}/validar-permissoes`, {
      permissoes
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao validar permissões:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao validar permissões');
  }
};
// Novo método para obter permissões disponíveis
export const obterPermissoesDisponiveis = async () => {
  try {
    const response = await api.get('/perfis-usuario/permissoes-disponiveis');
    return response.data;
  } catch (error) {
    console.error('Erro ao obter permissões disponíveis:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao obter permissões disponíveis');
  }
};

export const excluirPerfil = async (perfilId) => {
  try {
    const response = await api.delete(`/perfis-usuario/${perfilId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao excluir perfil:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao excluir perfil');
  }
};

// ⚡ ADICIONAR ESTA FUNÇÃO AQUI:
export const criarPerfilAcademico = async (dados) => {
  try {
    const response = await api.post('/auth/registro-admin-institucional', dados);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar perfil acadêmico:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao criar perfil acadêmico');
  }
};

export const alterarStatusPerfil = async (perfilId, status) => {
  try {
    const response = await api.patch(`/perfis-usuario/${perfilId}/status`, { status });
    return response.data;
  } catch (error) {
    console.error('Erro ao alterar status do perfil:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao alterar status do perfil');
  }
};

export const verificarPermissoes = async (perfilId, permissoes) => {
  try {
    const response = await api.post(`/perfis-usuario/${perfilId}/verificar-permissoes`, {
      permissoes
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao verificar permissões:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao verificar permissões');
  }
};

// --- Papéis extras no usuário (rolesExtra) ---

// Substitua as linhas 124-152 pelas versões corrigidas:

export const adicionarPapelExtra = async (usuarioId, role) => {
  try {
    const response = await api.post(`/auth/usuarios/${usuarioId}/roles-extra`, {
      action: 'add',
      role,
    });
    return response.data; // esperado: { success: true, rolesExtra: [...] }
  } catch (error) {
    console.error('Erro ao adicionar papel extra:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao adicionar papel extra');
  }
};

export const removerPapelExtra = async (usuarioId, role) => {
  try {
    const response = await api.post(`/auth/usuarios/${usuarioId}/roles-extra`, {
      action: 'remove',
      role,
    });
    return response.data; // esperado: { success: true, rolesExtra: [...] }
  } catch (error) {
    console.error('Erro ao remover papel extra:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao remover papel extra');
  }
};

export const obterPapeisExtra = async (usuarioId) => {
  try {
    const response = await api.get(`/auth/usuarios/${usuarioId}/roles-extra`);
    return response.data; // esperado: { rolesExtra: [...] }
  } catch (error) {
    console.error('Erro ao obter papéis extra:', error.response?.data);
    throw new Error(error.response?.data?.mensagem || 'Erro ao obter papéis extra');
  }
};


export default {
  criarPerfil,
  listarPerfis,
  obterPerfil,
  atualizarPerfil,
  excluirPerfil,
  alterarStatusPerfil,
  verificarPermissoes,
   criarPerfilAcademico,
  criarUsuarioPerfil,

 // 👇 adicione estas linhas
  adicionarPapelExtra,
  removerPapelExtra,
  obterPapeisExtra, // opcional
};


